import ReactDOM from "react-dom";
import React from "react";
import VoucherPortal from "./components/voucherPortal";

export function initHoponNamespace() {

  window.hopon = {};
  window.hopon.TM = function (tmObj) {
    this.container = tmObj.container;
    this.classes = tmObj.classes;
    const root = ReactDOM.createRoot(document.getElementById(this.container));
    root.render(
      <React.StrictMode>
        <VoucherPortal classes={ this.classes}></VoucherPortal>
      </React.StrictMode>
    );
  };
}
